module.exports = __webpack_public_path__ + "img/selo-gptw_1_1-2.d89308fc.png";